<div class="form-container" *ngIf="flow">
  <h1 class="ion-text-center ion-margin-bottom">
    {{ flow.name }}
  </h1>

  <!-- <p class="ion-text-center">
    Si hay algún dato erróneo en la factura corrigelo, <b>la información ingresada debe corresponder con la factura para
      que sea válida.</b>
  </p> -->
  <h5 class="ion-text-center">
    Por favor, completa la siguiente información para poder continuar:
  </h5>
  <div class="ion-margin-top ion-padding-top">
    <!-- <ion-card class="alert-button">
      <ion-item lines="none" class="alert-item">
        <ion-icon
          name="alert-circle-outline"
          slot="start"
          class="alert-icon"
        ></ion-icon>
        <ion-label>
          <p>
            ¿Quieres unirte y disfrutar de los beneficios?
            <strong (click)="getButtons()">Únete aquí</strong>.
          </p>
        </ion-label>
      </ion-item>
    </ion-card> -->
    <app-form [questions]="billQuestions"></app-form>
  </div>

  <ion-grid>
    <ion-row *ngIf="loadingQuestions">
      <ion-col size="8" sizeMd="6" class="ion-text-center" style="margin: auto">
        <ion-spinner name="crescent"></ion-spinner>
      </ion-col>
    </ion-row>
    <ion-row *ngIf="!loading">
      <ion-col size="8" sizeMd="6" style="margin: auto">
        <ion-button
          expand="block"
          class="ion-text-wrap"
          fill="clear"
          (click)="goBack()">
          Volver
        </ion-button>
      </ion-col>
      <ion-col size="8" sizeMd="6" style="margin: auto">
        <ion-button expand="block" class="ion-text-wrap" (click)="continue()">
          Continuar
        </ion-button>
      </ion-col>
    </ion-row>

    <ion-row *ngIf="loading">
      <ion-col size="8" sizeMd="6" class="ion-text-center" style="margin: auto">
        <ion-spinner name="crescent"></ion-spinner>
      </ion-col>
    </ion-row>
  </ion-grid>
</div>
